<template>
  <div class="container">
    <a-table
      class="tb"
      ref="dragTable"
      highlight-current-row="false"
      rowKey="key"
      :columns="renderColumns(columns)"
      :data-source="data"
      bordered
      size="middle"
      :scroll="{ x: 'calc(700px + 50%)', y: cusHeight }"
    >
      <template slot="headerName">
        <div class="hn-area">
          <div class="text-right">日期</div>
          <div class="text-left">产线</div>
          <div class="lineTable"></div>
        </div>
      </template>
    </a-table>
  </div>
</template>
<script>
export default {
    props: {
    cusHeight: {
      type: Number,
      default: 300
    }
  },
  data () {
    return {
      data: [],
      columns: [
        {
          slots: { title: 'headerName' },
          dataIndex: 'lineCode',
          key: 'lineCode',
          width: 120
        }
      ]
    }
  },
  mounted () {
    // 调用
  },
  methods: {
    // 在改动数据的方法中调用
    add () {
      this.$nextTick(() => this.setDrag())
    },
    renderColumns (columns) {
     const _this = this
    return columns.map(item => {
      return {
        ...item,
        customCell: (record, index) => {
          return _this.renderTimeBackground(record, index, item.dataIndex); // this.mergeCellsSlot 下面有合并行的具体代码
        }
      }
    })
    },
    renderTdBackground (record, index, flag) {
  if (flag === 1) {
      return {
        style: {
          'background-color': 'rgb(255,150,150)'
        }
      }
    }
    },
    renderTimeBackground (record, index, dataIndex) {
      if (record.age > 10 && dataIndex === 'name') {
          return this.renderTdBackground(record, index, 1)
      } else {
          return this.renderTdBackground(record, index, 0)
      }
    },
    initData (data) {
      // 使用 Set 来存储唯一的 startDate
      const uniqueDatesSet = new Set(data.map(item => item.startDate));
      // 将 Set 转换为数组
      const uniqueDatesArray = [...uniqueDatesSet];
      console.log(uniqueDatesArray)
      const tempColumns = [
        {
          slots: { title: 'headerName' },
          dataIndex: 'lineCode',
          key: 'lineCode',
          width: 144
        }
      ]
      uniqueDatesArray.forEach(item => {
        tempColumns.push({
          title: item,
          dataIndex: item
        })
      })
      this.columns = tempColumns
      this.data = this.generateNewArray(data)
    },
    generateNewArray (data) {
      return data.reduce((result, item) => {
        const { startDate, lineCode, lineLoad } = item;
        // 查找数组中是否已存在该 lineCode
        const existingItem = result.find(entry => entry.lineCode === lineCode);
        if (!existingItem) {
          // 如果不存在，创建新的项
          const newItem = {
            lineCode: lineCode,
            [startDate]: `${parseFloat((lineLoad * 100).toFixed(2))}%`
          };
          result.push(newItem);
        } else {
          // 如果已存在，添加新的日期和 lineLoad
          existingItem[startDate] = `${parseFloat((lineLoad * 100).toFixed(2))}%`;
        }
        return result;
      }, []);
    }
  }
}
</script>
<style lang="less" scoped>
.container {
  width: 100%
}
.tb {
  width: 100%;
}
.lineTable {
  content: '';
  position: absolute;
  width: 1px;
  height: 159px;
  top: -60px;
  left: 60px;
  background: #9faab1;
  display: block;
  transform: rotate(-67deg);
}
.hn-area {
  position: relative;
  width: 120px;
}
</style>
